import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useLazyQuery } from '@apollo/client';
import classNames from 'classnames';
import isClient from 'commons/isClient';
import { EMAIL_REGEX } from 'commons/constants';
import CtaButton from 'components/essentials/Cta/CtaButton';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import FacebookLogin from '../fb-signup/FacebookLogin';
import { GET_CUSTOMER_IS_EXISTS } from '../queries';
const PreLogin = t0 => {
  const $ = _c(46);
  const {
    state: t1,
    actions,
    isLoginPage,
    isFbLoading,
    staticContext,
    showGuestLogin,
    onGuestLoginClick
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {
      email: ""
    } : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const state = t2;
  const [fromURL, setFromURL] = useState("");
  const inputRef = useRef(null);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const location = useLocation();
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      fetchPolicy: "no-cache"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [getCustomerIsExists, t4] = useLazyQuery(GET_CUSTOMER_IS_EXISTS, t3);
  const {
    loading: customerExistsLoading,
    data: customerIsExists
  } = t4;
  let t5;
  let t6;
  if ($[3] !== location.search) {
    t5 = () => {
      if (isClient() && location.search) {
        const params = new URLSearchParams(location.search);
        if (params.get("from")) {
          setFromURL(params.get("from"));
        }
      }
    };
    t6 = [location.search];
    $[3] = location.search;
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[6] !== actions || $[7] !== customerIsExists) {
    t7 = () => {
      if (customerIsExists && customerIsExists.getCustomerIsExists) {
        if (customerIsExists.getCustomerIsExists.errors) {
          setIsEmailValid(false);
          if (inputRef && inputRef.current) {
            inputRef.current.focus();
          }
        } else {
          setIsEmailValid(true);
          actions.onCustomerExistsUpdate(customerIsExists.getCustomerIsExists.exists);
        }
      }
    };
    t8 = [customerIsExists, actions];
    $[6] = actions;
    $[7] = customerIsExists;
    $[8] = t7;
    $[9] = t8;
  } else {
    t7 = $[8];
    t8 = $[9];
  }
  useEffect(t7, t8);
  let t9;
  if ($[10] !== getCustomerIsExists || $[11] !== state.email) {
    t9 = async evt => {
      evt.preventDefault();
      evt.stopPropagation();
      const isUpdatedEmailValid = EMAIL_REGEX.test(String(state.email.trim()).toLowerCase());
      if (!isUpdatedEmailValid) {
        setIsEmailValid(false);
        return false;
      }
      await getCustomerIsExists({
        variables: {
          email: state.email.trim()
        }
      });
      return false;
    };
    $[10] = getCustomerIsExists;
    $[11] = state.email;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const onSubmit = t9;
  let redirectUri;
  if (isLoginPage) {
    redirectUri = isClient() ? window.location.href : "/";
  } else {
    redirectUri = `${isClient() ? window.location.origin : ""}/sign-in`;
  }
  let t10;
  if ($[13] !== fromURL) {
    t10 = fromURL && fromURL.length > 0 && <div className="return-link"><a href={fromURL}>← Return</a></div>;
    $[13] = fromURL;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <h2 className="text-xl font-bold text-gray m-0">Log in or create account</h2>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== actions.onFBCallback || $[17] !== isFbLoading || $[18] !== redirectUri || $[19] !== staticContext) {
    t12 = <FacebookLogin redirectUri={redirectUri} onFBCallback={actions.onFBCallback} staticContext={staticContext} isFbLoading={isFbLoading} />;
    $[16] = actions.onFBCallback;
    $[17] = isFbLoading;
    $[18] = redirectUri;
    $[19] = staticContext;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className={classNames("[background:none] h-3.5 relative text-center mt-[.825rem] mb-[1.875rem]", "[&_hr]:border-0 [&_hr]:![border-top:1px_solid_#f1f1f1] [&_hr]:mt-[-13px] [&_hr]:mx-auto [&_hr]:mb-2.5 [&_hr]:w-full")}><span className="text-xs inline-block relative -top-1.5 text-gray bg-gray-light9">or</span><hr aria-hidden="true" /></div>;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== state.email) {
    t14 = state.email.trim();
    $[22] = state.email;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== actions) {
    t15 = evt_0 => {
      setIsEmailValid(true);
      actions.onEmailChange(evt_0);
    };
    $[24] = actions;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = evt_1 => {
      const emailValid = EMAIL_REGEX.test(String(evt_1.target.value.trim()).toLowerCase());
      setIsEmailValid(emailValid);
    };
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  const t17 = !isEmailValid ? "Please enter a valid email address" : null;
  let t18;
  if ($[27] !== t14 || $[28] !== t15 || $[29] !== t17) {
    t18 = <LabeledTextInput name="email" value={t14} label="Email address" autoComplete="username" onChange={t15} onBlur={t16} errorMessage={t17} ref={inputRef} />;
    $[27] = t14;
    $[28] = t15;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  const t19 = customerExistsLoading || !isEmailValid;
  let t20;
  if ($[31] !== customerExistsLoading || $[32] !== t19) {
    t20 = <CtaButton type="submit" color="black" styling="solid-button" data-xc="signin-button" disabled={t19} block={true} isLoading={customerExistsLoading}>Continue</CtaButton>;
    $[31] = customerExistsLoading;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== onSubmit || $[35] !== t18 || $[36] !== t20) {
    t21 = <form method="POST" onSubmit={onSubmit}>{t18}{t20}</form>;
    $[34] = onSubmit;
    $[35] = t18;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== onGuestLoginClick || $[39] !== showGuestLogin) {
    t22 = !!showGuestLogin && <><div className={classNames("[background:none] h-3.5 relative text-center mt-[.825rem] mb-0", "[&_hr]:border-0 [&_hr]:![border-top:1px_solid_#f1f1f1] [&_hr]:mt-[-13px] [&_hr]:mx-auto [&_hr]:mb-2.5 [&_hr]:w-full")}><span className="text-xs inline-block relative -top-1.5 text-gray bg-gray-light9">or</span><hr aria-hidden="true" /></div><div className="text-center"><CtaButton size="sm" styling="link" color="brand" hasArrow={true} onClick={onGuestLoginClick}>Don't want an account? Continue as guest</CtaButton></div></>;
    $[38] = onGuestLoginClick;
    $[39] = showGuestLogin;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== t10 || $[42] !== t12 || $[43] !== t21 || $[44] !== t22) {
    t23 = <div className="text-gray"><div>{t10}{t11}{t12}{t13}{t21}{t22}</div></div>;
    $[41] = t10;
    $[42] = t12;
    $[43] = t21;
    $[44] = t22;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  return t23;
};
PreLogin.propTypes = {
  state: PropTypes.shape({
    email: PropTypes.string
  }),
  actions: PropTypes.shape({
    onFBCallback: PropTypes.func,
    onEmailChange: PropTypes.func,
    onCustomerExistsUpdate: PropTypes.func
  }),
  isLoginPage: PropTypes.bool,
  isFbLoading: PropTypes.bool,
  staticContext: PropTypes.shape({}),
  showGuestLogin: PropTypes.bool,
  onGuestLoginClick: PropTypes.func
};
export default PreLogin;